export default __webpack_public_path__ + "static/media/km.d64336f0.svg";